// Library Imports
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import "react-toastify/dist/ReactToastify.css";
import { Slide, ToastContainer } from 'react-toastify';

// Local Imports
import './index.css';
import App from './App.jsx';
import { BrowserRouter } from 'react-router';
import { persistor, store } from './redux/store.js';

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
        <ToastContainer
          autoClose={6000}
          hideProgressBar={true}
          closeOnClick={true}
          pauseOnFocusLoss={false}
          pauseOnHover
          transition={Slide}
          stacked
        />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
